// extracted by mini-css-extract-plugin
module.exports = {"contentItem":"_c6b9e3d","blockHtml":"_9a7a2b8","blockCta":"_4a34d14","icon":"_9426d99","wrapper":"_3b47ff4"};